<template>
<main class="content">
	<div class="row">
		<h1>
              Schedule New Video
          </h1>
	</div>
	<form validate v-on:submit.prevent="addVideo" class="form">
		<Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
		<fieldset class="form--item">
			<label class="label" for="">
                    Featured Video:
                </label>
			<div class="inputGroup">
				<div class="inputGroup--state" @click="video_type = 'featured'" v-bind:class="{'active': video_type == 'featured'}"></div>
				<div class="input_text">
					<v-select v-model="contentId" required :searchable="false" placeholder="Click to select a featured video" :options="featured"></v-select>
				</div>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                    Youtube or Vimeo Link:
                </label>
			<div class="inputGroup">
				<div class="inputGroup--state" @click="video_type = '3rdparty'" v-bind:class="{'active': video_type == '3rdparty'}"></div>
				<div class="input_text">
					<input name="" v-model="link" placeholder="Paste a URL link from a Youtube or Vimeo video under 14’55”" type="text" />
				</div>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  Wall:
              </label>
			<div class="input_text" id="wallId">
				<v-select v-model="wallId" required :searchable="false" placeholder="Click to select a wall" :options="walls"></v-select>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  Day:
              </label>
			<div class="input_text" id="starttime_date">
				<el-date-picker required v-model="starttime.date" type="date" placeholder="Click to select a day">
				</el-date-picker>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  Timeslot:
              </label>
			<div class="input_text" id="starttime_time">
				<el-time-select v-model="starttime.time" :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '23:45'
                      }" placeholder="Click to select a start timeslot">
				</el-time-select>
			</div>
		</fieldset>
		<div class="row">
			<button class="btn btn_blue" type="submit">
                  Add video
              </button>
		</div>
	</form>
	<loading :visible.sync="loadingVisible"></loading>
</main>
</template>

<script>
import * as HttpService from '../../services/http.service'
import vSelect from "vue-select"
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as CreateResource from '../../mixins/createResource.mixin';
import * as ValidateForm from '../../mixins/validate-form.mixin';

export default {
	name: 'EditSchedule',
	components: {
		vSelect,
		Message,
		Loading
	},
	mixins: [ValidateForm, CreateResource],
	data() {
		return {
			required_fields: [{
					'attribute': 'wallId',
					'message': 'WallId is missing',
					'id': 'wall_id'
				},
				{
					'attribute': 'starttime.date',
					'message': 'From day is missing',
					'id': 'starttime_date'
				},
				{
					'attribute': 'starttime.time',
					'message': 'From time is missing',
					'id': 'starttime_time'
				}
			],
			video_type: 'featured',
			resource: 'videos',
			parentResource: 'Pending',
			featured: [],
			wallId: '',
			contentId: '',
			link: '',
			walls: [],
			video: {
				source: 'featured'
			},
			starttime: {
				date: '',
				time: ''
			}
		}
	},
	created() {
		var self = this;
		HttpService.index('featured', {
			limit: 0
		}, function(response, error) {
			self.featured = response.result.data;
			self.featured = self.featured.map(item => {
				return {
					value: item.id,
					label: item.videoDetails.title
				}
			});
		});
		// self.featured = self.walls = [{value: 1, label: '1'}]
		HttpService.index('walls', {}, function(response, error) {
			self.walls = response.result.data;
			self.walls = self.walls.map(item => {
				return {
					value: item.id,
					label: item.name
				}
			});
		});
	},
	methods: {
		addVideo() {
			if (this.video_type == '3rdparty') {
				let link = this.generateLink();
				if (!link.url) {
					this.errorMessage = 'Invalid video link';
					return false;
				}
				this.video.contentId = link.url;
				this.video.platform = link.platform;
				this.video.source = '3rdparty';
			} else if (this.contentId) {
				this.video.contentId = this.contentId.value || this.video.contentId;
				this.video.source = 'featured'
			} else {
				this.errorMessage = 'Either Featured video or video link is required';
				return false;
			}

			if (this.validate()) {
				this.video.wallId = this.wallId.value || this.video.wallId;
				this.video.slot = this.getTimeslot(this.starttime);
			}
			this.createResource(this.video);
		},
		generateLink() {
			let parts = this.link.match(/(https?:[\/]{2})?(([w]{3}|m)\.)?(youtube\.com|youtu\.be)\/((watch\?v=)|(v\/))?([A-z\d-_]+)/) || this.link.match(/(https?:[\/]{2})([w]{3}\.)?vimeo\.com\/([\d]{8,12})/) || [];
			let platform = parts[8] ? 'youtube' : (parts[3] ? 'vimeo' : '');
			let url = parts[8] || parts[3];
			return {
				url: url,
				platform: platform
			};
		},
		getTimeslot(datetime) {
			let time = datetime.time.split(":");
			let slot = time[0] * 4 + time[1] / 15;

			let datestring = datetime.date;
			datestring = datestring.getFullYear() + '' + ("00" + (datestring.getMonth() + 1)).slice(-2) + ("00" + datestring.getDate()).slice(-2);

			return datestring + ("00" + slot).slice(-2);
		}
	},
	watch: {
		'link': function(val, change) {
			if (val) {
				this.video_type = '3rdparty';
				this.contentId = null;
			}
		},
		'contentId': function(val, change) {
			if (val && val.value) {
				this.video_type = 'featured'
				this.link = '';
			}
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AddSchedule.vue?223e683a